export const partnersSection = {
  title: 'Partners',
  description:
    'We strive to become leaders by working only with reliable and trusted partners with a well-known name. Each of our selections is based on high standards of quality and professionalism to provide our customers with only the best of the world of innovation. We believe that only mutually beneficial and honest cooperation with our partners will help you become the owner of your dream home.',
};
